module.exports = __webpack_public_path__ + "img/arrow.247463c6.svg";